import { Form } from 'antd'
import styled from 'styled-components'

import { DisplayInfoWrapper, SmallHeading } from './DisplayBlock.style'
import { getNotesId } from './utils/mapValuesToTemplate'

const Text = styled.span`
  ${({ theme }) => theme.font.label02}
  white-space: pre-wrap;
`

type Props = {
  notes: false | string
}

/**
 * Used directly when rendering the template in "display" mode
 */
export const DisplayNotes: React.FC<Props> = ({ notes }) => {
  return notes ? (
    <DisplayInfoWrapper>
      <SmallHeading>Notes</SmallHeading>
      <Text>{notes}</Text>
    </DisplayInfoWrapper>
  ) : null
}

type FormProps = {
  parentId: string
  initialNotes: Props['notes']
}

/**
 * Used when rendering the template in "capture" mode
 */
export const DisplayFormNotes: React.FC<FormProps> = ({
  parentId,
  initialNotes,
}) => {
  const notesId = getNotesId(parentId)

  return (
    <Form.Item dependencies={[notesId]} noStyle>
      {({ getFieldValue }) => {
        const notes = getFieldValue(notesId) || initialNotes

        return <DisplayNotes notes={notes} />
      }}
    </Form.Item>
  )
}
